import React, { useState } from "react";
import dayjs from "dayjs";

const Summary = ({ expenses }) => {
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const monthlyExpenses = expenses.filter((e) =>
    e.date.startsWith(selectedMonth)
  );

  const total = monthlyExpenses.reduce((sum, e) => sum + e.amount, 0);
  const count = monthlyExpenses.length;

  const categoryTotals = {};
  monthlyExpenses.forEach((e) => {
    categoryTotals[e.category] = (categoryTotals[e.category] || 0) + e.amount;
  });

  const highestCategory = Object.entries(categoryTotals).sort((a, b) => b[1] - a[1])[0]?.[0];

  return (
    <div className="summary">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
        <h3>📅 {dayjs(selectedMonth).format("MMMM YYYY")} Summary</h3>
        <input
          type="month"
          value={selectedMonth}
          onChange={handleMonthChange}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
        />
      </div>
      <p>Total Expenses: <strong>${total.toFixed(2)}</strong></p>
      <p>Transactions: {count}</p>
      <p>Top Category: {highestCategory || "N/A"}</p>
    </div>
  );
};

export default Summary;
